export const UPDATE_STORE_STAT_WIDGET = "UPDATE_STORE_STAT_WIDGET";